import { UserRightT } from 'business/definitions';
import { camelize, snakify } from 'helpers/syntaxHelper';

/**
 * Middleware meant to be used as a PreProcessingBodyCallback into APIClient.
 * Deals specifically with user_rights queries, by snakifying all values
 * passed into the body within the resourceType Key.
 */
export const userRightsPreProcessingBodyMiddleware = (body: UserRightT[]) =>
    body.map((userRight) => ({
        ...userRight,
        resourceType: snakify(userRight.resourceType),
    }));

/**
 * Middleware meant to be used as a PostProcessingCallback into APIClient.
 * Deals specifically with user_rights queries, by camelizing all values
 * returned in payload within the resourceType keys.
 */
export const userRightsPostProcessingMiddleware = (payload: {
    data: Record<string, UserRightT[]>;
}) => {
    const reformattedRights: Record<string, UserRightT[]> = {};

    Object.entries(payload.data).forEach(([userId, userRights]) => {
        reformattedRights[userId] = userRights.map((userRight) => ({
            ...userRight,
            resourceType: camelize(userRight.resourceType),
        }));
    });
    return { data: reformattedRights };
};
